import { isEmbarcacaoConsumoOperacaoEmpty } from "@/modules/embarcacoes/embarcacoes.types";
import type {
  EmbarcacaoConsumoOperacao,
  EmbarcacaoConsumoOperacaoState,
} from "@/modules/embarcacoes/embarcacoes.types";
import {
  useEmbarcacaoDetailSection,
  type EmbarcacaoDetailSectionQuery,
} from "./use-embarcacao-detail-section";

const CONSUMO_OPERACAO_QUERY: EmbarcacaoDetailSectionQuery<EmbarcacaoConsumoOperacao> = {
  select: (ficha) => ficha.consumoOperacao,
  isEmpty: isEmbarcacaoConsumoOperacaoEmpty,
  secao: "o Consumo Modo Operação",
};

interface UseEmbarcacaoConsumoOperacaoResult extends EmbarcacaoConsumoOperacaoState {
  reload: () => void;
}

/**
 * Consulta o Consumo Modo Operação da embarcação pedida. Somente leitura:
 * nenhuma escrita nem registro de auditoria na abertura da seção (AC5).
 */
export function useEmbarcacaoConsumoOperacao(id: string): UseEmbarcacaoConsumoOperacaoResult {
  const { data, ...state } = useEmbarcacaoDetailSection(id, CONSUMO_OPERACAO_QUERY);

  return { ...state, consumo: data };
}
